<template>
  <Dialog v-model:visible="showModal" class="w-11/12 lg:w-3/5 bg-white shadow rounded-xl" :modal="true" @show="loadSharingList">
    <template #header>
      <div class="w-full d2-dialog-header-title">{{lang['components']['Dialog']['SharingDialog']['title']}}</div>
    </template>

    <div class="px-2 lg:px-6">
      <!-- 方案資訊摘要 -->
      <div class="d2-sharing-summary">
        <div class="d2-sharing-summary-item">
          <div class="num">{{ payerInfo.plan_title }}</div>
          <div class="lbl">{{lang['components']['Dialog']['SharingDialog']['current_plan']}}</div>
        </div>
        <div class="d2-sharing-summary-item">
          <div class="num">{{ payerInfo.plan_use_num }}</div>
          <div class="lbl">{{lang['components']['Dialog']['SharingDialog']['original_num']}}</div>
        </div>
        <div class="d2-sharing-summary-item">
          <div class="num orange">{{ payerInfo.total_shared_num }}</div>
          <div class="lbl">{{lang['components']['Dialog']['SharingDialog']['shared_num']}}</div>
        </div>
        <div class="d2-sharing-summary-item">
          <div class="num blue">{{ payerInfo.effective_use_num }}</div>
          <div class="lbl">{{lang['components']['Dialog']['SharingDialog']['remaining_num']}}</div>
        </div>
      </div>

      <!-- 目前的跟隨者清單 -->
      <div class="mb-6" v-if="followers.length > 0">
        <div class="text-gray-600 font-semibold mb-3">{{lang['components']['Dialog']['SharingDialog']['follower_list']}}</div>

        <div v-for="follower in followers" :key="follower.sr_i"
          class="d2-follower-card" style="margin-bottom: 8px;">
          <div class="d2-follower-avatar">
            <i class="pi pi-user"></i>
          </div>
          <div style="flex: 1; min-width: 0;">
            <div style="font-size: 13px; font-weight: 600; color: var(--charcoal);" class="truncate">{{ follower.name }}</div>
            <div style="font-size: 12px; color: var(--slate);" class="truncate">{{ follower.email }}</div>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            <span style="background: var(--sky); color: var(--d2-blue); padding: 4px 12px; border-radius: 12px; font-size: 11px; font-weight: 600; white-space: nowrap;">
              {{lang['components']['Dialog']['SharingDialog']['activity_num']}}：{{ follower.use_num }}
            </span>
            <button
              class="d2-disconnect-btn"
              @click="removeFollower(follower)">
              <i class="pi pi-trash" style="margin-right: 4px;"></i>{{lang['components']['Dialog']['SharingDialog']['remove_btn']}}
            </button>
          </div>
        </div>
      </div>

      <div v-else-if="!isLoading" class="mb-6 text-center text-gray-400 text-sm py-4">
        {{lang['components']['Dialog']['SharingDialog']['no_followers']}}
      </div>

      <!-- 新增分享區塊 -->
      <hr class="d2-sharing-divider" />
      <div>
        <div style="font-size: 13px; font-weight: 600; color: var(--charcoal); margin-bottom: 12px;">{{lang['components']['Dialog']['SharingDialog']['add_sharing']}}</div>
        <div class="d2-sharing-form">
          <div>
            <label style="display: block; font-size: 12px; color: var(--slate); margin-bottom: 4px;">Email</label>
            <input
              type="email"
              v-model="newEmail"
              :placeholder="lang['components']['Dialog']['SharingDialog']['email_placeholder']"
              style="width: 100%; padding: 8px 12px; border: 1.5px solid rgba(0,0,0,0.12); border-radius: 8px; font-size: 13px; outline: none; font-family: var(--font-body);"
            />
          </div>
          <div>
            <label style="display: block; font-size: 12px; color: var(--slate); margin-bottom: 4px;">{{lang['components']['Dialog']['SharingDialog']['activity_num']}}（0-10）</label>
            <input
              type="number"
              v-model.number="newNum"
              min="0"
              max="10"
              style="width: 100%; padding: 8px 12px; border: 1.5px solid rgba(0,0,0,0.12); border-radius: 8px; font-size: 13px; outline: none; font-family: var(--font-body);"
            />
          </div>
          <div>
            <button
              class="d2-btn d2-btn-primary d2-btn-block"
              :disabled="isSubmitting"
              @click="addFollower">
              <span v-if="isSubmitting">{{lang['components']['Dialog']['SharingDialog']['submitting']}}</span>
              <span v-else><i class="pi pi-plus" style="margin-right: 4px;"></i>{{lang['components']['Dialog']['SharingDialog']['submit_btn']}}</span>
            </button>
          </div>
        </div>
        <div style="margin-top: 8px; font-size: 11px; color: var(--slate);">
          {{lang['components']['Dialog']['SharingDialog']['hint']}}
        </div>
      </div>
    </div>

    <template #footer>
      <div class="d2-btn-row" style="justify-content: flex-end;">
        <button
          class="d2-btn-ghost"
          @click="showModal=false">{{lang['components']['Dialog']['SharingDialog']['close_btn']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import axios from 'axios'
  import Qs from 'qs'
  import { API_BASE_URL, SITE_BASE_URL } from '../../api/config'

  export default {
    name: 'SharingDialog',
    components: {
      Dialog
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      lang: {
        type: Object,
        required: true
      }
    },
    emits: ['update:show'],
    data() {
      return {
        payerInfo: {
          plan_title: '',
          plan_use_num: 0,
          effective_use_num: 0,
          total_shared_num: 0
        },
        followers: [],
        newEmail: '',
        newNum: 1,
        isLoading: false,
        isSubmitting: false
      }
    },
    computed: {
      showModal: {
        get() {
          return this.show;
        },
        set(val) {
          this.$emit('update:show', val);
        }
      }
    },
    methods: {
      loadSharingList() {
        this.isLoading = true;
        axios.post(`${API_BASE_URL}/sharing_list.php`,
          Qs.stringify({
            s_code: this.$route.params.id
          }),
          { withCredentials: true }
        ).then((response) => {
          let data = response.data;
          if (data.status == 'success') {
            this.payerInfo = data.return_data.payer_info;
            this.followers = data.return_data.followers;
          } else if (data.status == 'login') {
            window.location.href = `${SITE_BASE_URL}/logout.php`;
          }
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      },

      addFollower() {
        if (!this.newEmail || this.newEmail.trim() === '') {
          Swal.fire({
            title: this.lang['components']['Dialog']['SharingDialog']['title'],
            text: this.lang['components']['Dialog']['SharingDialog']['email_required'],
            icon: 'warning'
          });
          return;
        }

        if (this.newNum < 0 || this.newNum > 10) {
          Swal.fire({
            title: this.lang['components']['Dialog']['SharingDialog']['title'],
            text: this.lang['components']['Dialog']['SharingDialog']['num_range_error'],
            icon: 'warning'
          });
          return;
        }

        this.isSubmitting = true;
        axios.post(`${API_BASE_URL}/sharing_add.php`,
          Qs.stringify({
            s_code: this.$route.params.id,
            email: this.newEmail.trim(),
            num: this.newNum
          }),
          { withCredentials: true }
        ).then((response) => {
          let data = response.data;
          if (data.status == 'success') {
            Swal.fire({
              title: this.lang['components']['Dialog']['SharingDialog']['title'],
              text: data.info,
              icon: 'success',
              timer: 2000,
              showConfirmButton: false
            });
            this.newEmail = '';
            this.newNum = 1;
            this.loadSharingList();
          } else if (data.status == 'login') {
            window.location.href = `${SITE_BASE_URL}/logout.php`;
          } else {
            Swal.fire({
              title: this.lang['components']['Dialog']['SharingDialog']['title'],
              text: data.info,
              icon: 'error'
            });
          }
          this.isSubmitting = false;
        }).catch(() => {
          this.isSubmitting = false;
          Swal.fire({
            title: this.lang['components']['Dialog']['SharingDialog']['title'],
            text: this.lang['components']['Dialog']['SharingDialog']['network_error'],
            icon: 'error'
          });
        });
      },

      removeFollower(follower) {
        Swal.fire({
          title: this.lang['components']['Dialog']['SharingDialog']['remove_confirm_title'],
          html: this.lang['components']['Dialog']['SharingDialog']['remove_confirm_text'].replace('{name}', follower.name).replace('{email}', follower.email),
          icon: 'warning',
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#ef4444',
          cancelButtonColor: '#9ca3af',
          confirmButtonText: this.lang['components']['Dialog']['SharingDialog']['confirm_btn'],
          cancelButtonText: this.lang['components']['Dialog']['SharingDialog']['cancel_btn']
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post(`${API_BASE_URL}/sharing_remove.php`,
              Qs.stringify({
                s_code: this.$route.params.id,
                with_member_id: follower.sr_i
              }),
              { withCredentials: true }
            ).then((response) => {
              let data = response.data;
              if (data.status == 'success') {
                Swal.fire({
                  title: this.lang['components']['Dialog']['SharingDialog']['title'],
                  text: data.info,
                  icon: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });
                this.loadSharingList();
              } else if (data.status == 'login') {
                window.location.href = `${SITE_BASE_URL}/logout.php`;
              } else {
                Swal.fire({
                  title: this.lang['components']['Dialog']['SharingDialog']['title'],
                  text: data.info,
                  icon: 'error'
                });
              }
            }).catch(() => {
              Swal.fire({
                title: this.lang['components']['Dialog']['SharingDialog']['title'],
                text: this.lang['components']['Dialog']['SharingDialog']['network_error'],
                icon: 'error'
              });
            });
          }
        });
      }
    }
  }
</script>
